import React from "react";
import {Trans, useTranslation} from "react-i18next";
import { InformatTheme } from "pu-crossproduct-components/build/themes";
import styled from "styled-components";
import { Body2, DisplayH1 } from "pu-crossproduct-components/build/components/Atoms/Type";

export const PageHolder = styled.div`
  padding: 0 50px;
`

export const General404: React.FC = props => {
    const {t} = useTranslation();
    return <>
        <InformatTheme>
            <PageHolder>
                <DisplayH1><Trans t={t}>error404Title</Trans></DisplayH1>
                <Body2><Trans t={t}>error404Description</Trans></Body2>
            </PageHolder>
        </InformatTheme>
    </>
}
